import { GET_MY } from '../../containers/App/constants';
import {
  ORB_DOMAIN,
  FETCH_ORB_STOCK,
  VALIDATE_RDW,
  CONFIRM_CAR,
  ORB_TRANSFER_OUT,
  GET_INCOMING_CARS,
  REQUEST_VEHICLE_TVI,
  RETRIEVE_VEHICLE_TVI,
} from './constants';

export function fetchORBStock(page) {
  console.log(page);
  return {
    type: GET_MY,
    work: ORB_DOMAIN,
    id: FETCH_ORB_STOCK,
    path: `ORB/stock?limit=50&offset=${page ? +page * 50 : 0}`,
  };
}

export function validateRDW(rdw) {
  return {
    type: GET_MY,
    work: ORB_DOMAIN,
    id: VALIDATE_RDW,
    path: `ORB/b2b/consult?rdw=${rdw}`,
  };
}

export function confirmIncomingCar(carInfo) {
  return {
    type: GET_MY,
    work: ORB_DOMAIN,
    id: CONFIRM_CAR,
    path: `ORB/b2b/confirm-incoming-car`,
    patch: carInfo,
    putOnComplete: getIncomingCars(null, 0, 100),
  };
}

export function orbTransferOut(carInfo, callback) {
  return {
    type: GET_MY,
    work: ORB_DOMAIN,
    id: ORB_TRANSFER_OUT,
    work: ORB_TRANSFER_OUT,
    gate: ORB_TRANSFER_OUT,
    path: `ORB/b2b/capture-transfer`,
    patch: carInfo,
    callback,
  };
}

export function getIncomingCars(info, offset = 0, limit = 100) {
  let params = info ? `info=${info}&` : '';
  params += `offset=${offset * limit}&limit=${limit}`;

  return {
    type: GET_MY,
    work: ORB_DOMAIN,
    id: GET_INCOMING_CARS,
    path: `ORB/b2b/open-transfer?${params}`,
  };
}

export function legacyORBTransfer(data, callback) {
  return {
    type: GET_MY,
    work: ORB_DOMAIN,
    patch: data,
    path: `ORB/legacytransfer`,
    callback,
  };
}

export function retrieveVehicleTVI(regplate, meldcode, callback) {
  return {
    type: GET_MY,
    work: RETRIEVE_VEHICLE_TVI,
    path: `orb/retrieve-tvi?regplate=${regplate}&meldcode=${meldcode}`,
    callback,
  };
}

export function requestVehicleTVI(vehicleId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_VEHICLE_TVI,
    patch: {},
    path: `orb/request-tvi/${vehicleId}`,
    callback,
  };
}
